import { message } from "antd";
import { UserInPackageAPI, UserInvestmentAdminAPI, UserInvestmentPackageStatsAPI, UserPackageSummaryAPI } from "./type";
import { API_URL, API_USER_URL } from "@/env";


const API_USE = API_USER_URL || '';
interface Package {
    id: number;
    name: string;
    description: string | null;
    price: string;
    total_slots: number;
    remaining_slots: number;
    sold_slots?: number;
    monthly_commission_rate: string;
    commission_rate: string;
    commission_start_month: number;
    duration_months: number;
    min_profit_rate: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
    image: string | null;
    part_per_user: number;
    high_profit_rate: string;
    high_rate_duration: number;
    tax_rate: string;
    type: string;
    parent?: {
        id: number;
        name: string;
        remaining_slots: number;
    };
}

interface PackageListAPI {
    status: boolean;
    data: {
        current_page: number;
        data: Package[];
        first_page_url: string;
        from: number;
        last_page: number;
        last_page_url: string;
        links: {
            url: string | null;
            label: string;
            active: boolean;
            page: number | null;
        }[];
        next_page_url: string | null;
        path: string;
        per_page: number;
        prev_page_url: string | null;
        to: number;
        total: number;
    };
}
async function fetchPackageUserList(): Promise<PackageListAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/packages`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to fetch package list');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        message.error('Lỗi khi lấy danh sách gói');
        throw error;
    }
}

async function fetchPackageAdminList(): Promise<PackageListAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/packages`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to fetch package list');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        message.error('Lỗi khi lấy danh sách gói');
        throw error;
    }
}

async function fetchUserPackages(page?: number, status?: string): Promise<UserInvestmentAdminAPI> {

    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const queryParams = new URLSearchParams();
        if (page !== undefined) queryParams.append('page', page.toString());
        if (status !== undefined) queryParams.append('status', status);
        const response = await fetch(`${API_USE}/api/v1/be/admin/user-packages?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to fetch user packages');
        }

        const data: UserInvestmentAdminAPI = await response.json();
        return data;
    }
    catch (error) {
        message.error('Lỗi khi lấy gói đầu tư người dùng');
        throw error;
    }
}

async function userInvestmentPackageStats(userId: string, history_page?: number, trans_page?: number, comm_page?: number, doc_page?: number): Promise<UserInvestmentPackageStatsAPI> {

    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const queryParams = new URLSearchParams();
        if (history_page !== undefined) queryParams.append('history_page', history_page.toString());
        if (trans_page !== undefined) queryParams.append('trans_page', trans_page.toString());
        if (comm_page !== undefined) queryParams.append('comm_page', comm_page.toString());
        if (doc_page !== undefined) queryParams.append('doc_page', doc_page.toString());
        const response = await fetch(`${API_USE}/api/v1/be/admin/user-packages/stats/${userId}?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to fetch user investment package stats');
        }

        const data: UserInvestmentPackageStatsAPI = await response.json();
        return data;
    }
    catch (error) {
        message.error('Lỗi khi lấy thống kê gói đầu tư người dùng');
        throw error;
    }
}

async function fetchPackageDetails(packageId: number): Promise<Package> {

    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/packages/${packageId}`, {
            method: 'GET',  
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to fetch package details');
        }

        const data = await response.json();
        return data.data as Package;
    } catch (error) {
        message.error('Lỗi khi lấy chi tiết gói');
        throw error;
    }

}

async function getCurrentUserInPackage(packageId: number): Promise<UserInPackageAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/packages/users/${packageId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to fetch users in package');
        }

        const data: UserInPackageAPI = await response.json();
        return data;
    } catch (error) {
        message.error('Lỗi khi lấy người dùng trong gói');
        throw error;
    }
}

async function fetchPackageSummary(): Promise<UserPackageSummaryAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }
    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/user-packages/summary`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to fetch package summary');
        }

        const data: UserPackageSummaryAPI = await response.json();
        return data;
    } catch (error) {
        message.error('Lỗi khi lấy tổng quan gói');
        throw error;
    }
}

async function updatePackageAdmin(packageId: number, payload: Record<string, any>) {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/packages/${packageId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to update package');
        }

        return await response.json();
    } catch (error) {
        message.error('Lỗi khi cập nhật gói');
        throw error;
    }
}

export {
    fetchPackageUserList,
    fetchPackageAdminList,
    fetchUserPackages,
    userInvestmentPackageStats,
    fetchPackageDetails,
    getCurrentUserInPackage,
    fetchPackageSummary,
    updatePackageAdmin
};